import { getHisTypeIdByTitle } from '@/pages/Onboarding/options/HisType/utils/getHisType';
import { getHisVoiceIdByTitle } from '@/pages/Onboarding/options/HisVoice/utils/getHisVoice';
import { getShowLoveIdByTitle } from '@/pages/Onboarding/options/ShowLove/utils/getShowLove';

import { layoutDataDefault } from '../constants';
import { LayoutDataType } from '../types';

type LayoutDataTypeFromUser = Omit<
  LayoutDataType,
  'his_type' | 'his_voice' | 'show_love'
> & {
  his_type: string;
  his_voice: string;
  show_love: string;
};

export const normalizeOnbDataToForm = (
  onb_data: LayoutDataTypeFromUser,
): LayoutDataType => {
  return {
    ...layoutDataDefault,
    his_type: getHisTypeIdByTitle(onb_data.his_type),
    his_voice: getHisVoiceIdByTitle(onb_data.his_voice),
    show_love: getShowLoveIdByTitle(onb_data.show_love),
    name: onb_data.name || layoutDataDefault.name,
    email: onb_data.email || layoutDataDefault.email,
  };
};
